import {ComponentType} from 'react';

import {Renderer} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DraftMessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {MessagePatch} from '../../../../helpers/models/messagePatchHelpers';
import {withReplyTo} from '../reply/withReplyTo';
import {Quote} from './quote';

/*
 * Props.
 */

export interface QuoteContainerProps {
  message: DraftMessageModel;
  isQuoteVisible: boolean;
  onToggleIsQuoteVisible: () => void;
  isAlwaysEditing: boolean;
  saveMessageAsync: (patch: MessagePatch) => void;
  renderEditor: Renderer;
  hasFocus?: boolean;
}

/*
 * Component.
 */

export const QuoteContainer: ComponentType<QuoteContainerProps> = withReplyTo(Quote);
